
// Required elements for bootstrap to work
import '../../../Modules/Ngpa.ToolKat.FO.Module.CMS/wwwroot/js/signature.js'; //le console.log("ToolKat")
import jQuery from 'jquery'
import 'popper.js/dist/umd/popper'

// Carousel
import 'owl.carousel/dist/assets/owl.carousel.css'
import 'owl.carousel'

// Sass files
import './scss/main.scss'

// Startup js
import Startup from './js/startup'

window.$ = jQuery;

// bootstrap the app
Startup();